import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

const ui = constants.colors.ui;
const borderColor = ui.core[600];
const white = ui.white[25];

export const baseWrapperStyles: CSSObject = {
  backgroundColor: ui.white[25],
  borderRadius: "6px",
};

export const baseStyles: CSSObject = {
  background: `linear-gradient(
    281.41deg,
    ${fullGradientColors.position100.color} 0%,
    ${fullGradientColors.position50.color} 48.95%,
    ${fullGradientColors.position25.color} 73.43%,
    ${fullGradientColors.position0.color} 97.9%
  )`,
  border: `1px solid ${borderColor}`,
  padding: "1px",
  borderRadius: "8px",
  display: "flex",
  flexFlow: "column",
  marginBottom: "30px",
  top: "-10px",
  left: "-6px",
  width: "100%",
  position: "relative",
  zIndex: "2",
  "::before": {
    content: "''",
    height: "calc(100% + 32px)",
    border: `2px solid ${white}`,
    position: "absolute",
    left: "-5px",
    top: "-20px",
  },
};
